import { Box, Button, Grid } from "@mui/material"
import { SolveAdjudicationCaseDecision, SolveAdjudicationCaseAttack } from "neurotec-megamatcherid-management-client"
import AdjudicationRejectButton from "./AdjudicationRejectButton"
import React from "react"

interface IAdjudicationActionButtonsProps {
    extraButton?: JSX.Element
    disabled?: boolean
    handleSolve: (decision: SolveAdjudicationCaseDecision, attack: SolveAdjudicationCaseAttack) => void
}

const AdjudicationActionButtons: React.FC<IAdjudicationActionButtonsProps> = (props) => {

    return (
        <>
        <Grid item xs={4} container justifyContent="flex-start">
            <Box style={{padding: "0.5rem"}}>
                <Button disabled={props.disabled} variant="contained" color="primary" onClick={() => props.handleSolve(SolveAdjudicationCaseDecision.DecisionAccepted, "UNRECOGNIZED")}>
                    Accept
                </Button>
            </Box>
        </Grid>
        <Grid item xs={8} container justifyContent="flex-end">
            <Box style={{ padding: "0.5rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                {props.extraButton}
                <Button
                    disabled={props.disabled}
                    color="error"
                    variant="contained"
                    onClick={() => props.handleSolve(SolveAdjudicationCaseDecision.DecisionRejectedAge, SolveAdjudicationCaseAttack.AttackNone)}
                >
                    Reject age
                </Button>
                <AdjudicationRejectButton
                    disabled={props.disabled}
                    solve={(attack) => props.handleSolve(SolveAdjudicationCaseDecision.DecisionRejectedLiveness, attack)}
                >
                    Reject liveness
                </AdjudicationRejectButton>
            </Box>
        </Grid></>
    )
}

export default AdjudicationActionButtons